module.exports = __webpack_public_path__ + "img/service3-2.13b8cd1b.webp";